import {RootState} from 'app/state/store';

export const customersSelector = ({customers: {items}}: RootState) => items;
export const areCustomersLoadingSelector = ({customers: {isLoading}}: RootState) => isLoading;
export const areCustomersDetailsLoadingSelector = ({customers: {isLoadingDetails}}: RootState) =>
    isLoadingDetails;
export const periodSelector = ({customers: {period}}: RootState) => period;
export const customersErrorCodeSelector = ({customers: {hasErrorCode}}: RootState) => hasErrorCode;
